// ─── Phase Close Probabilities ────────────────────────────────────────────────
// These are placeholder percentages. 
// Each phase maps to a % likelihood the deal will close.

export const SELLER_PHASES = [
  { theme: "New Lead",       group: 1, closeProbability: 10,  color: "#94a3b8" },
  { theme: "Lead",           group: 2, closeProbability: 20,  color: "#60a5fa" },
  { theme: "Document Prep",  group: 3, closeProbability: 30,  color: "#818cf8" },
  { theme: "Listing Prep",   group: 4, closeProbability: 30,  color: "#a78bfa" },
  { theme: "MLS",            group: 5, closeProbability: 50,  color: "#f472b6" },
  { theme: "Active",         group: 6, closeProbability: 50,  color: "#fb923c" },
  { theme: "Under Contract", group: 7, closeProbability: 80,  color: "#facc15" },
  { theme: "Pre-close",      group: 8, closeProbability: 90,  color: "#a3e635" },
  { theme: "Closed",         group: 9, closeProbability: 100, color: "#75BB2E" },
];

export const BUYER_PHASES = [
  { theme: "New Lead",       group: 1, closeProbability: 10,  color: "#94a3b8" },
  { theme: "Lead",           group: 2, closeProbability: 20,  color: "#60a5fa" },
  { theme: "Active Showing", group: 3, closeProbability: 50,  color: "#818cf8" },
  { theme: "Offer Prep",     group: 4, closeProbability: 60,  color: "#f472b6" },
  { theme: "Under Contract", group: 5, closeProbability: 80,  color: "#fb923c" },
  { theme: "Pre-close",      group: 6, closeProbability: 90,  color: "#a3e635" },
  { theme: "Closed",         group: 7, closeProbability: 100, color: "#75BB2E" },
];

// ─── Helper — get phases for a deal type ─────────────────────────────────────
export const getPhasesForDeal = (dealType) => {
  return dealType === "Buyer" ? BUYER_PHASES : SELLER_PHASES;
};

// ─── Helper — get close probability for a deal based on furthest active phase ─
export const getCloseProbability = (deal, tasks) => {
  const phases = getPhasesForDeal(deal.type);
  if (!tasks || tasks.length === 0) return phases[0].closeProbability;

  // Find the furthest phase that has at least one completed task
  let furthestPhase = phases[0];
  for (const phase of phases) {
    const phaseTasks = tasks.filter(t => t.theme === phase.theme);
    const completed = phaseTasks.filter(t => t.status === "complete").length;
    if (completed > 0) furthestPhase = phase;
  }
  return furthestPhase.closeProbability;
};